module.exports = __webpack_public_path__ + "static/media/2015_conf_A_Product_Manager_Should_Own_a_Job.3018b45a.png";